import { Link } from "react-router-dom";
import classes from "./Footer.module.css";
import Logo from "../img/logo.png";

// Icons
import LinkedinIcon from "../img/linkedin-icon.svg";
import FacebookIcon from "../img/facebook-icon.svg";
import InstagramIcon from "../img/instagram-icon.svg";

export default function Footer() {
  return (
    <footer className={classes.footer}>
      <div className="container">
        <div className={classes.info}>
          <div className={classes["info-and-address"]}>
            <div className={classes.social}>
              <a href="#">
                <img src={LinkedinIcon} />
              </a>
              <a href="#">
                <img src={FacebookIcon} />
              </a>
              <a href="#">
                <img src={InstagramIcon} />
              </a>
            </div>
            <h4>
              Α. Παπαδήμα 22 <br />
              Κομοτηνή
            </h4>
          </div>
          <img src={Logo} alt="logo image" className={classes.logo}/>
        </div>
        <div>
          <h4>Τομείς Δικαίου</h4>
          <ul>
            <li>
              <Link to="/fields/criminal-law">Ποινικό Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/civil-law">Αστικό Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/public-law">Δημόσιο Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/military-law">Στρατιωτικό Δίκαιο</Link>
            </li>
          </ul>
        </div>
        <div>
          <h4>Τομείς Δικαίου</h4>
          <ul>
            <li>
              <Link to="/fields/criminal-law">Ποινικό Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/civil-law">Αστικό Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/public-law">Δημόσιο Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/military-law">Στρατιωτικό Δίκαιο</Link>
            </li>
          </ul>
        </div>
        <div>
          <h4>Τομείς Δικαίου</h4>
          <ul>
            <li>
              <Link to="/fields/criminal-law">Ποινικό Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/civil-law">Αστικό Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/public-law">Δημόσιο Δίκαιο</Link>
            </li>
            <li>
              <Link to="/fields/military-law">Στρατιωτικό Δίκαιο</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
